<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-sms-workflow'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to SMS Workflows</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-sms-workflow'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addSmsWorkflow">Add Workflow</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <div class="container-wrapper">
        <primary-input
          type="text"
          name="name sms workflow"
          class="field"
          v-model="smsWorkflow.sms_workflow_name"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('name sms workflow')}"
          placeholder="Type a name of SMS Workflow"
        />
        <div class="help is-danger" v-if="errors.has('first name')">{{ errors.first('first name') }}</div>
        <div class="sub-wrapper">
          <div class="trigger">
            <div class="body">
              <div class="trigger-icon">
                <svg
                  class="svg-trigger"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M24.7133515,13.5075766 L15.4490463,5.20674095 C15.1919891,4.97649025 14.8079564,4.97649025 14.5509537,5.20674095 L5.2866485,13.5075766 C5.00376022,13.7610585 4.97542234,14.2010585 5.22337875,14.4903621 C5.47133515,14.7794986 5.90179837,14.8085237 6.18468665,14.5549861 L6.90201635,13.912312 L6.90201635,24.2696379 C6.90201635,24.6542061 7.20697548,24.9660167 7.58321526,24.9660167 L12.7457766,24.9660167 L17.2542234,24.9660167 L22.4167302,24.9660167 C22.79297,24.9660167 23.0979292,24.6542061 23.0979292,24.2696379 L23.0979292,13.9123677 L23.8152589,14.5550975 C23.9445777,14.6708635 24.1046866,14.7277994 24.2639782,14.7277994 C24.453406,14.7277994 24.6418529,14.6475209 24.7765123,14.4904178 C25.0246322,14.2010585 24.9962943,13.7611142 24.7133515,13.5075766 Z M13.4269755,23.5733148 L13.4269755,17.8366574 L16.57297,17.8366574 L16.57297,23.5733148 L13.4269755,23.5733148 Z M21.7356403,12.6969916 L21.7356403,23.5732591 L17.9355313,23.5732591 L17.9355313,17.1402786 C17.9355313,16.7557103 17.6304632,16.4438997 17.2543324,16.4438997 L12.7458856,16.4438997 C12.3697003,16.4438997 12.0646866,16.7557103 12.0646866,17.1402786 L12.0646866,23.5733148 L8.26446866,23.5733148 L8.26446866,12.6969916 C8.26446866,12.6952089 8.26425068,12.6935376 8.26425068,12.6918106 L15,6.65643454 L21.7358583,12.6917549 C21.7359128,12.6935933 21.7356403,12.6952089 21.7356403,12.6969916 Z M13.4741144,11.5592201 C13.4741144,11.943844 13.7790736,12.2555989 14.1553134,12.2555989 L15.8446866,12.2555989 C16.2208719,12.2555989 16.5258856,11.943844 16.5258856,11.5592201 C16.5258856,11.1745961 16.2208719,10.8628412 15.8446866,10.8628412 L14.1553134,10.8628412 C13.7791281,10.8628412 13.4741144,11.1745961 13.4741144,11.5592201 Z"
                    id="path-1"
                  ></path>
                </svg>
              </div>
              <div class="trigger-form">
                <primary-select
                  type="text"
                  name="trigger"
                  class="select"
                  v-validate="'required'"
                  v-model="smsWorkflow.workflow.trigger.recipient_uuid"
                  :class="{'input': true, 'is-danger': errors.has('first name')}"
                  placeholder="Choose Trigger"
                >
                  <!-- <option value="" disabled hidden selected>Choose trigger</option> -->
                  <option
                    v-for="(recipient, k) in recipients"
                    :key="k"
                    :value="recipient.recipient_uuid"
                  >{{recipient.recipient_name}}</option>
                </primary-select>
                <div
                  class="help is-danger"
                  v-if="smsWorkflowError"
                >{{smsWorkflowError.recipient ? smsWorkflowError.recipient : null}}</div>
              </div>
            </div>
          </div>
          <div class="reminder-workflow-form">
            <action
              v-if="smsWorkflow.workflow.root_action.action"
              :action="smsWorkflow.workflow.root_action.action"
              :tail="60"
              @removeAction="onRemoveAction"
            ></action>
            <condition
              v-if="smsWorkflow.workflow.root_action.condition"
              :condition="smsWorkflow.workflow.root_action.condition"
              :tail="60"
              @removeCondition="onRemoveCondition"
            ></condition>
            <add-action-or-condition
              v-else
              @addAction="onAddAction"
              @addCondition="onAddCondition"
              :tail="30.5"
            ></add-action-or-condition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AddActionOrCondition: () =>
      import("@/components/EditRate/AddActionOrCondition.vue"),
    Action: () => import("@/components/EditRate/Action.vue"),
    Condition: () => import("@/components/EditRate/Condition.vue")
  },
  data: () => ({
    smsWorkflowError: null,
    smsWorkflow: {
      sms_workflow_name: null,
      workflow: {
        root_action: {
          action: null,
          condition: null
        },
        trigger: {
          recipient_uuid: null
        }
      }
    },
    recipients: []
  }),
  created() {
    this.recipientList();
  },
  methods: {
    recipientList: async function() {
      let res = await this.$store.dispatch("GetRecipientList", {});
      const total = res.total;
      res = await this.$store.dispatch("GetRecipientList", { perPage: total });
      this.recipients = res.items;
    },
    onAddAction: function() {
      if (this.smsWorkflow.workflow.root_action.action) return;

      this.smsWorkflow.workflow.root_action.action = {
        action: null,
        call_date_time: null,
        delay_before_action: null
      };
    },
    onAddCondition: function() {
      if (
        this.smsWorkflow.workflow.root_action.condition ||
        !this.smsWorkflow.workflow.root_action.action
      )
        return;

      let reAction;

      switch (this.smsWorkflow.workflow.root_action.action.action) {
        case 'at work text':
          reAction = {
            action: 're-send at work text',
            delay_before_action: null
          };
          break;
        case 'schedule call':
          reAction = {
            action: 'text re-schedule call'
          };
          break;
        default:
          reAction = null;
          break;
      }

      this.smsWorkflow.workflow.root_action.condition = {
        condition: "response received",
        condition_yes: {
          action: null,
          condition: null
        },
        condition_no: {
          action: reAction,
          condition: null
        }
      };
    },
    onRemoveAction: function() {
      this.onRemoveCondition();
      this.smsWorkflow.workflow.root_action.action = null;
    },
    onRemoveCondition: function() {
      this.smsWorkflow.workflow.root_action.condition = null;
    },
    clearTree: function(original_branch) {
      // Creating a copy of branch
      let branch = JSON.parse(JSON.stringify(original_branch));
      if(branch.action.call_date_time) {
        // branch.action.call_date_time.toISOString();
        // console.log("branch.action.call_date_time-->", branch.action.call_date_time)
      }
      if (!branch.action) {
        delete branch.action;
      } else if (!branch.action.call_date_time) {
        delete branch.action.call_date_time;
      }

      if (!branch.condition) {
        delete branch.condition;
      } else {
        const condition_yes = this.clearTree(branch.condition.condition_yes);
        const condition_no = this.clearTree(branch.condition.condition_no);

        if (!condition_yes) {
          delete branch.condition.condition_yes;
        } else {
          branch.condition.condition_yes = condition_yes;
        }
        if (!condition_no) {
          delete branch.condition.condition_no;
        } else {
          switch (condition_no.action.action) {
            case 're-send at work text':
            condition_no.action.action = 'at work text'
              break;
            case 'text re-schedule call':
            condition_no.action.action = 'schedule call'
              break;
            // default:
            //   reAction = null;
            //   break;
          }
          branch.condition.condition_no = condition_no;
        }

        if (
          !branch.condition.condition &&
          !branch.condition.condition_yes &&
          !branch.condition.condition_no
        ) {
          delete branch.condition;
        }
      }

      let isEmpty = true;

      for (let prop in branch) {
        if (branch.hasOwnProperty(prop)) {
          isEmpty = false;
          break;
        }
      }

      if (isEmpty) {
        branch = null;
      }

      return branch;
    },
    addSmsWorkflow: async function() {
      const valid = await this.$validator.validate();

      if (!valid) return;

      const root_action = this.clearTree(this.smsWorkflow.workflow.root_action);

      console.log(this.smsWorkflow);

      this.$store
        .dispatch("AddSmsWorkflow", {
          sms_workflow_name: this.smsWorkflow.sms_workflow_name,
          workflow: {
            root_action: this.clearTree(this.smsWorkflow.workflow.root_action),
            trigger: {
              recipient_uuid: this.smsWorkflow.workflow.trigger.recipient_uuid
            }
          }
        })
        .then(() => {
          this.$snotify.success("SMS Workflow have been added.", {
            timeout: 6000
          });
          this.$router.push({ name: "company-admin-sms-workflow" });
        })
        .catch(err => {
          if (err.errors) {
            this.smsWorkflowError = err.errors[0].smsWorkflow
              ? err.errors[0].smsWorkflow
              : null;
            setTimeout(() => {
              this.smsWorkflowError = null;
            }, 6000);
          } else {
            this.$snotify.error(err.response.data.errors, {
              timeout: 6000
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 150px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 15px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 221px;
    width: 375px;
    font-family: "Helvetica Neue";
    .container-wrapper {
      width: 100%;
      margin-top: 10px;
      .field {
        width: 345px;
      }
      .sub-wrapper {
        justify-content: space-between;
        width: 100%;
        margin-top: 30px;
        .vertical-line {
          width: 0;
          border-left: 2px solid #bdbfd8;
          margin-left: 29px;
        }
        .horizontal-line {
          border-bottom: 2px solid #bdbfd8;
          margin-left: 29px;
        }
        .trigger {
          .body {
            display: flex;
            .trigger-icon {
              height: 60px;
              width: 60px;
              border-radius: 30px;
              background-color: #51a3f3;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
              text-align: center;
              padding: 15px 0;
              .svg-trigger {
                height: 30px;
                width: 30px;
                fill: #ffffff;
              }
            }
            .trigger-form {
              .select {
                width: 300px;
                margin-left: 15px;
              }
              .help {
              }
              .is-danger {
              }
            }
          }
        }
        .reminder-workflow-form {
          display: inline-flex;
          flex-direction: column;
          margin-left: 10px;
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>